"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileNameAndExtension = void 0;

var getFileNameAndExtension = function getFileNameAndExtension(file) {
  return file.get('name') + "." + file.get('extension');
};

exports.getFileNameAndExtension = getFileNameAndExtension;